import { useQuery } from "@tanstack/react-query";
import { storefrontApiRequest } from "@/lib/shopify";
import { contextualCurrency } from "@/lib/storefront-cart-context";

const LOCALIZATION_CURRENCIES = `query storefrontCurrencies($country: CountryCode!) @inContext(country: $country) {
  localization { country { isoCode currency { isoCode } } availableCountries { isoCode currency { isoCode } } }
}`;

export function useStorefrontCurrencies(country: string, enabled = true) {
  return useQuery({
    queryKey: ["storefront-currencies", country], enabled,
    queryFn: async (): Promise<Record<string, string>> => {
      const response = await storefrontApiRequest<any>(LOCALIZATION_CURRENCIES, { country }, { cacheTtlMs: 0 });
      const localization = response?.data?.localization;
      const currencies: Record<string, string> = {};
      for (const entry of localization?.availableCountries ?? []) {
        currencies[entry.isoCode] = contextualCurrency(entry.isoCode, entry.isoCode, entry.currency?.isoCode);
      }
      // A resolved fallback is not evidence for the requested country.
      currencies[country] = contextualCurrency(country, localization?.country?.isoCode, localization?.country?.currency?.isoCode);
      return currencies;
    },
    staleTime: 60_000,
  });
}